// Shared Admissions CRM constants & helpers
export const ADMISSION_STAGES = [
  "New", "Attempted", "Connected", "Interested", "Documents Pending",
  "Application Started", "Application Submitted", "Admission Confirmed", "Fees Paid", "Lost",
];

export const WON_STAGES = ["Admission Confirmed", "Fees Paid"];
export const CLOSED_STAGES = ["Fees Paid", "Lost"];

export const STATUS_TO_STAGE = {
  new: "New", contacted: "Attempted", interested: "Interested",
  admitted: "Admission Confirmed", lost: "Lost",
};

export const STAGE_COLORS = {
  "New": "bg-blue-100 text-blue-700",
  "Attempted": "bg-sky-100 text-sky-700",
  "Connected": "bg-cyan-100 text-cyan-700",
  "Interested": "bg-violet-100 text-violet-700",
  "Documents Pending": "bg-amber-100 text-amber-700",
  "Application Started": "bg-orange-100 text-orange-700",
  "Application Submitted": "bg-indigo-100 text-indigo-700",
  "Admission Confirmed": "bg-emerald-100 text-emerald-700",
  "Fees Paid": "bg-green-100 text-green-700",
  "Lost": "bg-slate-200 text-slate-600",
};

export const PRIORITY_COLORS = {
  High: "bg-red-100 text-red-700",
  Medium: "bg-amber-100 text-amber-700",
  Low: "bg-slate-200 text-slate-600",
};

export const STATUS_COLORS = {
  new: "bg-blue-100 text-blue-700",
  contacted: "bg-amber-100 text-amber-700",
  interested: "bg-purple-100 text-purple-700",
  admitted: "bg-emerald-100 text-emerald-700",
  lost: "bg-slate-200 text-slate-600",
};

export const SOURCE_LABELS = {
  ai_counseling: "AI Counseling",
  expert_counseling: "Expert",
  contact_form: "Contact",
  college_page_cta: "College CTA",
};

export const stageOf = (l) => l?.stage || STATUS_TO_STAGE[l?.status] || "New";

const MS_PER_DAY = 86400000;

// Days since an ISO/date string. Returns null if no date.
export function daysSince(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d)) return null;
  const ms = Date.now() - d.getTime();
  return Math.max(0, Math.floor(ms / MS_PER_DAY));
}

const todayStr = () => new Date().toISOString().slice(0, 10);
export function isOverdue(nextFollowUp, stage) {
  if (!nextFollowUp) return false;
  if (CLOSED_STAGES.includes(stage)) return false;
  return nextFollowUp < todayStr();
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return iso; }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }); }
  catch { return iso; }
}

export function waLink(lead) {
  const num = (lead?.whatsappNumber || lead?.mobile || "").replace(/\D/g, "").slice(-10);
  const text = encodeURIComponent(`Hi ${lead?.name || ""}, this is CollegeUnlock admission team.`);
  return `https://wa.me/91${num}?text=${text}`;
}
